import FormattedMessage from 'I18n/components/FormattedMessage';
import { Body, BreezeLogo, LayoutBox, LayoutVertical } from 'breeze-intelligence-kit';
import { SectionMatchRateContainer } from './SectionMatchRate';
import { useDataTest } from './useDataTest/useDataTest';
import { MatchRateCards } from './MatchRateCards';
import { METER_BLOCK_SIZE, TEXT_BLOCK_SIZE } from './constants';
import { useEnrichableObjectTypes } from '../EnrichableObjectTypesProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const DataTestLoading = ({
  children
}) => {
  const {
    isContactEnrichment,
    isLoading
  } = useDataTest();
  const {
    companyLabelPluralLowercase,
    contactLabelPluralLowercase
  } = useEnrichableObjectTypes();
  const Message = () => {
    if (isContactEnrichment) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dataTest.panel.loadingContacts",
        options: {
          objectType: contactLabelPluralLowercase
        }
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dataTest.panel.loadingCompanies",
      options: {
        objectType: companyLabelPluralLowercase
      }
    });
  };
  if (isLoading) {
    return /*#__PURE__*/_jsxs(SectionMatchRateContainer, {
      children: [/*#__PURE__*/_jsx(LayoutVertical, {
        alignItems: "center",
        blockSize: METER_BLOCK_SIZE,
        justifyContent: "center",
        children: /*#__PURE__*/_jsx(BreezeLogo, {
          inlineSize: "3.75rem"
        })
      }), /*#__PURE__*/_jsx(LayoutBox, {
        minBlockSize: TEXT_BLOCK_SIZE,
        textAlign: "center",
        children: /*#__PURE__*/_jsx(Body, {
          children: /*#__PURE__*/_jsx(Message, {})
        })
      }), /*#__PURE__*/_jsx(MatchRateCards, {
        isContactEnrichment: isContactEnrichment,
        isLoading: true,
        recordsEligible: 0,
        recordsEnrichable: 0,
        recordsSelected: 0
      })]
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};